import React from 'react';
import { AedContext } from './aed-context';
import { AedStore, aedStore } from './aed-store';

export function AedProvider(props: {
    children: React.ReactElement;
    value: AedStore;
}): React.ReactElement {
    return <AedContext.Provider value={aedStore}>{props.children}</AedContext.Provider>;
}
